// Copyright (c) 2020 Deere & Company

import './error-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const ErrorAlertBar = props => (
    <div className="error-alert-bar">
        <AlertBarBase
            alertTitle={props.alertTitle}
            canDismiss={props.canDismiss}
            dismissHandler={props.dismissHandler}
            iconClass="icon-alert-warning-white"
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>
);

ErrorAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

ErrorAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false
};
